/*global VXConfig*/

import Translations from "../../../utils/Translations";
import {VXPay}      from "../../../utils/VXPay";
import {getCurrencySymbol} from '../../../utils/CommonUtils.js';

function getLanguage() {
	let language = (VXConfig.language).toUpperCase();
	if (language !== 'DE' && language !== 'EN') {
		language = 'EN';
	}
	return language;
}

function getPrice(price) {
	const language  = getLanguage();
	let priceString = price.toString() + getCurrencySymbol();
	if (language === 'DE') {
		priceString = priceString.replace('.', ',');
	}
	return priceString;
}

function openPaytour(priceInEUR, bonusCode) {
	const priceInCent = priceInEUR * 100;
	const options     = {
		texts:             {
			TicketButtonOK: Translations.get('ChatVXPayBuyTicketNow'),
		},
		environment:       'vxone',
		allowNoPaymentFee: true,
		excludePayments:   ['CT', 'Voice'],
		minAmount:         priceInCent,
		onlyCustomAmounts: true,
		selectedAmount:    priceInCent,
	};

	if (bonusCode) {
		options.hidePaymentCode = true;
		options.option          = bonusCode;
	}

	if (priceInCent > 0) {
		options.amounts = [priceInCent, 3000, 6000, 10000];
	}

	VXPay.openPaytour(options);
}

export {
	getLanguage,
	getPrice,
	openPaytour,
};
